import { Editor, Range } from 'slate';

export type MarkNodesAsSelected = (at?: Range, annotationId?: string) => void;

export default function markNodesAsSelected(editor: any): MarkNodesAsSelected {
  return function (at?: Range): void {
    if (at) {
      Editor.addMark(editor, 'isSelected', true);
    }
  };
}
